// extracted by mini-css-extract-plugin
export default {"resumeGameModal":"resumeGameModal_resumeGameModal__WPgiq","footer":"resumeGameModal_footer__XXU9e"};